// ── API Configuration ─────────────────────────────────────────────────────
// Change API_BASE here to update the base URL across the entire app.

export const API_BASE = "https://api.pmsdemo.uleval.com";

// ── Endpoint helpers ──────────────────────────────────────────────────────
export const ENDPOINTS = {
  // Auth
  login: `${API_BASE}/profiler-account/login`,

  // Profiler account
  me: `${API_BASE}/profiler-account/me`,
  profilerById: (id) => `${API_BASE}/profiler-account/${id}`,

  // Tenant
  tenantProfile: (phoneNumber) => `${API_BASE}/tenants/profile/${phoneNumber}`,
};
